import React, { useState, useEffect, useContext } from 'react'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import {
    Form,
    Button,
    Row,
    Col,
    Input,
    Card,
    CardBody,
    FormGroup,
    Label,
    CardTitle
} from "reactstrap"
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Select from 'react-select'
import { updateAvatar, updateProfile } from '../../../store/actions'

const FormPage = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [id, setId] = useState()
    const [customerId, setCustomerId] = useState(null)
    const [branchId, setBranchId] = useState(null)
    const [roleId, setRoleId] = useState()
    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    const [password, setPassword] = useState()
    const [password2, setPassword2] = useState()

    const splitFullName = (fullName = '') => {
        const [first = '', ...rest] = `${fullName}`.trim().split(/\s+/)
        return { firstName: first, lastName: rest.join(' ') }
    }

    // catalogs
    const [roles, setRoles] = useState([])
    const [customers, setCustomers] = useState([])
    const [branches, setBranches] = useState([])

    useEffect(() => {
        if (props.data !== undefined) {
            const { data } = props

            setRoleId(roles.find(i => i.value === data.roleId))
            setCustomerId(customers.find(i => i.value === data.customerId))
            setBranchId(branches.find(i => i.value === data.branchId))

            setId(data.id)
            const names = splitFullName(data.fullName)
            setFirstName(data.firstName || names.firstName)
            setLastName(data.lastName || names.lastName)
            setEmail(data.email)
            setPhone(data.phone)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data])

    useEffect(() => {
        (async () => {
            await getRoles()
            await getCustomers()
        })()
    }, []) // eslint-disable-line

    useEffect(() => {
        (async () => {
            if (!customerId) { return }

            await fetchBranchesByCustomerId(customerId.value)
        })()
    }, [customerId, fetchBranchesByCustomerId])

    const getRoles = async () => {
        setLoading(true)
        const result = await ApiService.getRoles()
        let roles = []

        result.data.data.map((role) => {
            const item = {
                value: role.id,
                label: role.name,
                codeName: role.codeName
            }

            return roles.push(item)
        })

        setLoading(false)
        setRoles(roles)
    }

    async function fetchBranchesByCustomerId(customerId) {
        try {
            setLoading(true)
            const response = await ApiService.getBranchesByCustomerId(customerId)
            let branches = []

            response.data.branches.map((b) => {
                return branches.push({
                    value: b.id,
                    label: b.branchName,
                })
            })

            setLoading(false)
            setBranches(branches)
        } catch (error) {
            toastr.error(`No pude extraer las sucursales`)
        } finally {
            setLoading(false)
        }
    }

    const getCustomers = async () => {
        setLoading(true)
        const result = await ApiService.getCustomers()
        let customers = []

        result.data.customers.map((customer) => {
            const item = {
                value: customer.id,
                label: customer.businessName,
            }

            return customers.push(item)
        })

        setLoading(false)
        setCustomers(customers)
    }

    const _handleSubmit = async (e) => {
        e.preventDefault()

        if (password !== password2) {
            toastr.error(`Passwords does not match`)
            document.getElementById('password').style.border = '1px solid red'
            document.getElementById('password2').style.border = '1px solid red'

            return
        } else {
            document.getElementById('password').style.border = '1px solid #ced4da'
            document.getElementById('password2').style.border = '1px solid #ced4da'
        }

        if (roleId === undefined || roleId.value === '') {
            toastr.error(`No olvides seleccionar un rol`)
            return
        }

        if (!_validateForm()) {
            toastr.error('No olvides llenar los campos.', 'Error')

            return
        }

        try {
            setLoading(true)

            let data = {
                customerId: customerId ? customerId.value : null,
                branchId: branchId ? branchId.value : null,
                roleId: roleId.value,
                fullName: `${firstName || ''} ${lastName || ''}`.trim(),
                email,
                phone,
                password
            }

            if (props.data !== undefined) {
                await _updateUser(id, data)

                return
            }

            await _createUser(data)

            props.history.push('/users')
        } catch (error) {
            console.log(error)
            toastr.error(`I couldn't add this user`)
        } finally {
            setLoading(false)
        }
    }

    const _updateUser = async (id, data) => {
        setLoading(true)

        try {
            const response = await ApiService.updateUser({
                ...data,
                id
            })

            if (!response.data.success) {
                toastr.error(response.data.message, 'Error')

                return false
            }

            if (props.user?.id === id) {
                props.updateProfile({
                    ...props.user,
                    ...data,
                    id
                })
            }
            window.analytics.track('User updated')
            toastr.success(`User Edited`, '¡Éxito!')
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const _createUser = async (data) => {
        setLoading(true)

        try {
            const response = await ApiService.createUser(data)

            if (!response.data.success) {
                toastr.error(response.data.message, 'Error')

                return false
            }

            window.analytics.track('User Added')
            toastr.success(`User Added`, '¡Éxito!')
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const _validateForm = () => {
        if (firstName === '') { return false }
        if (email === '') { return false }
        if (password === '') { return false }
        if (phone === '') { return false }

        return true
    }

    return (
        <React.Fragment>
            <Form id="lugares" method="POST" onSubmit={_handleSubmit}>
                <Row>
                    <Col sm={12}>
                        <Card style={{ textAlign: 'right' }}>
                            <CardBody>
                                <Button
                                    onClick={() => { window.history.go(-1) }}
                                    className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    <i className={`mdi mdi-check`}></i> Guardar
                                </Button>
                            </CardBody>
                        </Card>

                        <Col sm={12} md={4}>
                            <Card>
                                <CardBody>
                                    <CardTitle>Generales</CardTitle>

                                    <p></p>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm={12} md={8}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm={12} lg={6}>
                                            <FormGroup>
                                                <Label>Cliente</Label>

                                                <Select
                                                    id={`customerId`}
                                                    value={customerId}
                                                    defaultValue={customerId}
                                                    placeholder={`Clientes...`}
                                                    onChange={value => setCustomerId(value)}
                                                    options={customers}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={12} lg={6}>
                                            <FormGroup>
                                                <Label>Sucursal</Label>

                                                <Select
                                                    id='branchId'
                                                    value={branchId}
                                                    defaultValue={branchId}
                                                    placeholder="Sucursales..."
                                                    onChange={(value) => {
                                                        setBranchId(value)
                                                    }}
                                                    options={branches}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={12} lg={6}>
                                            <FormGroup>
                                                <Label htmlFor="firstName">
                                                    Nombre/s
                                                </Label>

                                                <Input
                                                    id="firstName"
                                                    name="firstName"
                                                    type="text"
                                                    className="form-control"
                                                    value={firstName}
                                                    onChange={event => setFirstName(event.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={12} lg={6}>
                                            <FormGroup>
                                                <Label htmlFor="lastName">
                                                    Apellido/s
                                                </Label>

                                                <Input
                                                    id="lastName"
                                                    name="lastName"
                                                    type="text"
                                                    className="form-control"
                                                    value={lastName}
                                                    onChange={event => setLastName(event.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={12} lg={4}>
                                            <FormGroup>
                                                <Label htmlFor="email">
                                                    Email
                                                </Label>

                                                <Input
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    className="form-control"
                                                    value={email}
                                                    onChange={event => setEmail(event.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={12} lg={4}>
                                            <FormGroup>
                                                <Label>
                                                    Teléfono
                                                </Label>

                                                <Input
                                                    type="tel"
                                                    className="form-control"
                                                    value={phone}
                                                    onChange={event => setPhone(event.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={12} lg={4}>
                                            <FormGroup>
                                                <Label htmlFor="roleId">
                                                    Rol
                                                </Label>

                                                <Select
                                                    id={`roleId`}
                                                    value={roleId}
                                                    placeholder={`Roles...`}
                                                    onChange={value => setRoleId(value)}
                                                    options={roles}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={12} lg={6}>
                                            <FormGroup>
                                                <Label htmlFor="password">
                                                    Password
                                                </Label>

                                                <Input
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    className="form-control"
                                                    value={password}
                                                    onChange={event => setPassword(event.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={12} lg={6}>
                                            <FormGroup>
                                                <Label htmlFor="password">
                                                    Confirmar Password
                                                </Label>

                                                <Input
                                                    id="password2"
                                                    name="password2"
                                                    type="password"
                                                    className="form-control"
                                                    value={password2}
                                                    onChange={event => {
                                                        setPassword2(event.target.value)
                                                    }}
                                                    onBlur={e => {
                                                        if (password !== password2) {
                                                            toastr.error(`Passwords does not match`)
                                                            document.getElementById('password').style.border = '1px solid red'
                                                            document.getElementById('password2').style.border = '1px solid red'

                                                            document.getElementById('password2').focus()
                                                        } else {
                                                            document.getElementById('password').style.border = '1px solid #ced4da'
                                                            document.getElementById('password2').style.border = '1px solid #ced4da'
                                                        }
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return { user: state.Auth.profile }
}

export default connect(
    mapStatetoProps, { updateAvatar, updateProfile }
)(withRouter(FormPage))
